import { useEffect, useState } from "react";
import { fetchBookingPrices } from "../features/hotel/hotelApi";
import { type IDailyPrices } from "../features/pricing/pricingInterface";
import { getFallbackDailyPrices } from "../helpers/dailyPrices";

let dailyPricesRequest: Promise<IDailyPrices> | null = null;

const loadDailyPrices = (): Promise<IDailyPrices> => {
  if (dailyPricesRequest === null) {
    dailyPricesRequest = fetchBookingPrices()
      .then((response) => response.data as IDailyPrices)
      .catch((error) => {
        console.warn("Failed to load booking prices from ChAPI, using fallback", error);
        return getFallbackDailyPrices();
      });
  }
  return dailyPricesRequest;
};

export function useDailyPrices(): IDailyPrices | null {
  const [dailyPrices, setDailyPrices] = useState<IDailyPrices | null>(null);

  useEffect(() => {
    let active = true;
    loadDailyPrices().then((prices) => {
      if (active) setDailyPrices(prices);
    });
    return () => {
      active = false;
    };
  }, []);

  return dailyPrices;
}
